module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/de81ddb02e4b3bed0ac0c7e4a822944d.png";